import { render, staticRenderFns } from "./ButtonListUsers.vue?vue&type=template&id=60f12e85&"
import script from "./ButtonListUsers.vue?vue&type=script&lang=ts&"
export * from "./ButtonListUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports